// extracted by mini-css-extract-plugin
module.exports = {"link":"_2lsio","root":"o1y2F","label":"_19Zgu"};